import firestore from "../config/firebase";
import { firebaseApp } from "../config/firebase";
import axios from "axios";
import { baseUrl } from "../config/app.config";

import { getAreaTeamBranchForGroupBy } from "../views/SalesReport/SalesReport.service";

export const getReportStatusInfoById = async (docId, collectionName) => {
  return await firestore
    .collection(collectionName)
    .doc(docId)
    .get();
};

export const getTilesByProcedureName = async (
  area,
  team,
  office,
  financialYear,
  month,
  procedureName,
  groupBy
) => {
  let result = { error: false, data: "" };

  var areaTeamBranch = getAreaTeamBranchForGroupBy(area, team, office, groupBy);

  try {
    var response = await axios.get(
      baseUrl +
        "/api/Sales/GetDrillDownDetails?marea=" +
        areaTeamBranch.area +
        "&mteam=" +
        areaTeamBranch.team +
        "&office=" +
        areaTeamBranch.branch +
        "&financialYear=" +
        financialYear +
        "&mmonth=" +
        month +
        "&procedureName=" +
        procedureName
    );

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }

  return result;
};

export const UploadImage = async (file, fileName) => {
  return await firebaseApp
    .storage()
    .ref("SummerNoteUploads/" + fileName)
    .put(file);
};

export const createorUpdateDocument = async (docId, collectionName, data) => {
  var resultData = {};
  var result = await firestore
    .collection(collectionName)
    .doc(docId)
    .set(
      {
        data
      },
      { merge: true }
    )
    .then(function() {
      resultData = data;
    })
    .catch(function(error) {
      resultData = {};
    });

  return resultData;
};

export const getReportFilters = async () => {
  let result = { error: false, data: "" };

  try {
    var response = await axios.get(baseUrl + "/api/Reports/GetReportFilters");
    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }
  return result;
};

export const getAllReportMenus = async () => {
  let result = { error: false, data: "" };

  try {
    var response = await axios.get(
      baseUrl + "/api/Reports/GetAllStatusReportMenu"
    );
    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }
  return result;
};
